<template>
    <v-dialog v-model="dialogShow" fullscreen  style="z-index: 9999999">
        <v-card style="width:100%;height:100%;text-align: center;background-color: rgba(0, 0, 0, 0.4)">
            <v-row style="width:100%;height:100%;" align-content="center" justify="center" class="ma-0">
                <v-progress-circular :size="40" indeterminate color="primary"></v-progress-circular>
                <div style="font-size: 16px;font-weight: 400;color: white;line-height: 40px;text-align: center;margin-left: 16px">{{dialogText}}</div>
            </v-row>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
      name: "DialogLoading",
      props:["dialogShow","dialogText"],
      destroyed() {
        this.$parent.loadingDialogText = "加载中……"
      }
    }
</script>

<style scoped>

</style>
